import { InventoryService } from "../services/inventoryService";

export class InventoryComponent extends HTMLElement {
    private container: HTMLElement;
    private _inventoryService: InventoryService = new InventoryService();

    public constructor() {
        super();
        const shadow: ShadowRoot = this.attachShadow({ mode: "open" });

        this.container = document.createElement("div");
        this.container.id = "inventory-root";
        shadow.appendChild(this.container);
    }

    public connectedCallback(): void {
        void this.fetchInventory();
    }

    public renderInventory(items: string[]): void {
        this.container.innerHTML = "";

        const style: HTMLStyleElement = document.createElement("style");
        style.textContent = `
      :host {
        position: fixed;
        top: 10px;
        left: 10px;
        z-index: 1000;
        display: block;
        box-sizing: border-box;
        font-family: 'Press Start 2P', monospace, sans-serif;
      }

      .inventory-wrapper {
        background: #e0e0e0;
        border: 2px solid #000;
        border-radius: 4px;
        padding: 10px;
        width: 260px;
        box-shadow: 4px 4px 0 #000;
      }

      .inventory-title {
        font-size: 50px;
        text-transform: uppercase;
        margin-bottom: 8px;
        color: #111;
      }

      .inventory-grid {
        list-style: none;
        padding: 0;
        margin: 0;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
      }

      .item {
        background: #fff;
        border: 2px solid #000;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 72px;
        height: 72px;
        image-rendering: pixelated;
        transition: transform 0.1s ease;
      }

      .item:hover {
        transform: scale(1.08);
        background: #f7f7f7;
      }

      .item .img-wrap {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .item img {
        width: 48px;
        height: 48px;
        image-rendering: pixelated;
      }

      .item .fallback {
        display: none;
        font-size: 18px;
        font-weight: bold;
      }

          .empty {
        grid-column: 1 / -1;
        text-align: center;
        color: #444;
        font-size: 10px;
        padding: 6px;
      }

      @media (max-width: 420px) {
        :host {
          top: 5px;
          left: 5px;
          transform: scale(0.9);
        }
      }
    `;

        this.container.appendChild(style);

        const wrapper: HTMLDivElement = document.createElement("div");
        wrapper.className = "inventory-wrapper";

        const listHtml: string =
            items.length === 0
                ? "<li class=\"empty\">No items in inventory.</li>"
                : items
                    .map((item: string) => {
                        const fallbackChar: string =
                              item && item.length ? item.charAt(0).toUpperCase() : "?";
                        const imgSrc: string = `../assets/img/items/${item.toLowerCase()}Image.png`;
                        return `
                <li class="item">
                  <div class="img-wrap">
                    <img src="${imgSrc}" alt="${item}"
                      onerror="this.style.display='none'; const fb=this.parentElement.querySelector('.fallback'); if(fb) fb.style.display='inline-block';">
                    <span class="fallback">${fallbackChar}</span>
                  </div>
                </li>
              `;
                    })
                    .join("");

        wrapper.innerHTML = `
      <div class="inventory-title">Inventory</div>
      <ul class="inventory-grid">${listHtml}</ul>
    `;

        this.container.appendChild(wrapper);
    }

    private async fetchInventory(): Promise<void> {
        const container: HTMLElement = this.container;
        container.innerHTML = "<div style=\"padding:12px;\">Loading inventory...</div>";
        try {
            const res: Response = await this._inventoryService.getInventory();
            if (!res.ok) throw new Error("Failed to fetch inventory");

            const items: string[] = (await res.json()) as string[];
            this.renderInventory(items);
        }
        catch (err) {
            const errorMessage: string = err instanceof Error ? err.message : "An unknown error occurred";
            container.innerHTML = `<div style="color:red;padding:12px;">Error: ${errorMessage}</div>`;
        }
    }
}

// Registreren van het custom element
if (!customElements.get("inventory-component")) {
    customElements.define("inventory-component", InventoryComponent);
}
